import { useEffect, useState } from "react";
import { ContainerScreenGeneral, MuniSpinner2 } from "../../../components";
import { getInfraccionAprobadaConImagenes, getInfraccionesAprobadas } from "./handlers";
import { tableData } from "./tableData";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import Table2 from "../../../components/Table2";
import ModalInfraccionMCD from "../../../views/modals/ModalInfraccionMCD";
import ModalMapaMCD from "../../../views/modals/ModalMapaMCD/ModalMapaMCD";
import FilterEstadosMCD from "./components/FilterEstadosMCD";


const InfraccionesAprobadas = () => {
  const [infraccionesNuevas, setInfraccionesNuevas] = useState({
    data: null,
    loading: true,
    infraccion_seleccionada: null,
  });
  const [estadoSeleccionado, setEstadoSeleccionado] = useState("all");

  const { modals, handlerModal, loads } = useGeneralAppStore();

  useEffect(() => {
    const getInfraccionesNuevas = async () => {
      await getInfraccionesAprobadas(setInfraccionesNuevas);
    };

    getInfraccionesNuevas();
  }, []);

  const getInfraccionCompleta = async (id) => {
    const resp = await getInfraccionAprobadaConImagenes(
      // infraccionesNuevas.infraccion_seleccionada.id,
      id,
      setInfraccionesNuevas,
      // setIsLoading
    );
    if (resp) {
      // handlerModal({ modal: true, modalName: "infraccion_por_aprobar" })
      handlerModal({ modal: true, modalName: "infraccion_mcd" })
    }
  };

  const infraccionesFiltradas =
    estadoSeleccionado === "all"
      ? infraccionesNuevas?.data ?? []
      : (infraccionesNuevas?.data ?? []).filter(
          (infraccion) => String(infraccion?.afm?.estado_id) === String(estadoSeleccionado)
        );

  console.log(infraccionesNuevas?.data);
  
  return (
    <>
      <ContainerScreenGeneral linkBack={"/mcd"} titulo={"MCD - Infracciones aprobadas"} size={"lg"}>
        {infraccionesNuevas.loading ? (
          <MuniSpinner2 />
        ) : (
          infraccionesNuevas?.data?.length > 0 && (
            <div className="w-100 mx-auto mt-4" style={{ maxWidth: "750px" }}>
              <Table2
                rowsPerPageOptions={[20]}
                pageSize={20}
                height={"80vh"}
                loading={loads?.includes('detalle_denuncia')}
                data={tableData(infraccionesFiltradas)}
                render={() => (
                  <FilterEstadosMCD
                    data={infraccionesNuevas?.data ?? []}
                    estadoSeleccionado={estadoSeleccionado}
                    setEstadoSeleccionado={setEstadoSeleccionado}
                    loading={loads?.includes('detalle_denuncia')}
                  />
                )}
                rowClick={(e) => {
                  setInfraccionesNuevas((prevState) => ({
                    ...prevState,
                    infraccion_seleccionada: e.row,
                  }));
                  getInfraccionCompleta(e.id);
                  // handlerModal({ modal: true, modalName: "infraccion_por_aprobar" });
                }}
                name="infracciones_nuevas"
              />
            </div>
          )
        )}
      </ContainerScreenGeneral>

      {modals.includes("infraccion_mcd") && infraccionesNuevas?.infraccion_seleccionada && infraccionesNuevas?.data?.length > 0 && (
        <ModalInfraccionMCD
          infraccionesNuevas={infraccionesNuevas}
          setInfraccionesNuevas={setInfraccionesNuevas}
          aprobadas={true}
        />
      )}
      {modals.includes("mapa_denuncias") && (
        <ModalMapaMCD infracciones={infraccionesNuevas?.data} />
      )}


    </>
  );
};

export default InfraccionesAprobadas;
